import React, { Component } from 'react';
import "./Popup.scss"

class Popup extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    handleClick(event) {
        event.stopPropagation();
    }
    render() {
        return (
            <div>
                <div className={`fade ${this.props.isActive ? " active" : ""}`} onClick={() => this.props.togglePopup("")}></div>
                <div className="closeable">
                    <div className={`popup ${this.props.isActive ? " active" : ""} ${this.props.context ? this.props.className : ""}`}>
                        <div className="padding">
                            <div className="close" onClick={() => this.props.togglePopup("")}></div>
                            <div className="container">
                                {this.props.isActive ? this.props.context : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Popup/Popup.jsx